export class OpportunityCreatedMode {
    OpportunityModeID: number;
    OpportunityModeName: string;
    OpportunityModeDescription: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}